import React from 'react';
import { useStylesForDonutChart } from './DonutChartStyle';
export function polarToCartesian(
  centerX: number,
  centerY: number,
  radius: number,
  angleInDegrees: number
) {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
}

function Arc(props: {
  x: number;
  y: number;
  radius: number;
  startAngle: number;
  endAngle: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  const { x, y, radius, endAngle, startAngle } = props;
  const startV = startAngle >= 360 ? 359.9 : startAngle;
  const endV = endAngle >= 360 ? 359.9 : endAngle;
  const start = polarToCartesian(x, y, radius, endV);
  const end = polarToCartesian(x, y, radius, startV);
  const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

  if (Math.abs(startAngle - endAngle) < 0.1) return null;

  const donut = ['M', start.x, start.y, 'A', radius, radius, 0, largeArcFlag, 0, end.x, end.y].join(
    ' '
  );

  return <path d={donut} style={props.style} className={props.className} />;
}

export type PieChartValue = {
  color: string;
  value?: number;
  angle?: number;
};

// https://stackoverflow.com/questions/58948890/how-to-apply-custom-animation-effect-keyframes-in-materialui-using-makestyles

export const DonutChart = (props: {
  title?: string;
  subTitle?: string;
  angle?: number;
  pros?: number;
  color: string;
}) => {
  const style = useStylesForDonutChart();
  const { angle, pros, color } = props;
  let calcAngle = typeof angle !== 'undefined' ? angle : ((pros || 0) / 100) * 360;
  const realAngle = calcAngle < 0 ? 0 : calcAngle >= 360 ? 360 : calcAngle;
  const startAngle = 0;
  const endAngle = realAngle;

  return (
    <svg viewBox="0 0 300 300" className={style.DonutChart}>
      <g>
        <Arc
          x={150}
          y={150}
          startAngle={0}
          endAngle={359.9}
          radius={100}
          className={style.background}
        />
        {props.title ? (
          <text
            x={150}
            y={150 - (props.subTitle ? 10 : 0)}
            className={style.text}
            textAnchor="middle"
            alignmentBaseline={props.subTitle ? 'baseline' : 'middle'}
          >
            {props.title}
          </text>
        ) : null}
        {props.subTitle ? (
          <text
            x={150}
            y={159}
            className={style.subtitle}
            textAnchor="middle"
            alignmentBaseline="hanging"
          >
            {props.subTitle}
          </text>
        ) : null}

        <Arc
          x={150}
          y={150}
          startAngle={startAngle}
          endAngle={endAngle}
          radius={100}
          style={{ stroke: color }}
          className={style.line}
        />
      </g>
    </svg>
  );
};

export default DonutChart;
